import React from 'react';
import Card from '../../../../components/Card';

function SupportConfirmation() {
  return (
    <Card className={'mt-3'}>
      <div className={'B1'}>
        Спасибо!
        <br />
        <br />
        Ваши предложения уже рассматриваются. В случае одобрения их включат в список мер поддержки,
        которые будут опубликованы на <a href={'http://government.ru'}>сайте Правительства</a>.
      </div>
    </Card>
  );
}

export default SupportConfirmation;
